<template>
  <div id="home"></div>
</template>
<script>
export default {
  name: "Home",
  props: {},
  data() {
    return {
      imgUrl:require("@/assets/img/bg.jpg")
    };
  },
  components: {}, 
};
</script>
<style scoped lang="less">
#home {
  padding-top: 54px;
  
}
</style>